import { NgModule } from "@angular/core";
import { AdminCommonModule } from "../admin-common.module";
import { AuditReprotManagementComponent} from "./audit-report-management.component";
import { ModalModule} from 'angular2-modal';
import { BootstrapModalModule} from 'angular2-modal/plugins/bootstrap';

@NgModule({
    declarations: [
        AuditReprotManagementComponent
    ],
    imports: [
        AdminCommonModule,
        ModalModule.forRoot(),
        BootstrapModalModule
    ],
    exports :[]
    
})
export class AuditReportSiteModule {
}


// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/views/admin/audit-report/audit-report.module.ts